import { Component, HostBinding, Input, OnInit } from '@angular/core';

@Component({
    selector: 'fuse-nav-vertical-item',
    templateUrl: './nav-vertical-item.component.html',
    styleUrls: ['./nav-vertical-item.component.scss']
})
export class FuseNavVerticalItemComponent implements OnInit {
    @HostBinding('class') classes = 'nav-item';
    @Input() item: any;
    sub: any;
    submenu = false;

    constructor() {
        this.sub = localStorage.getItem('currentUserRole');
        console.log(this.sub)



    }

    ngOnInit() {
        if (this.item.title !== 'Kontrol Paneli' && this.item.title !== 'Kategoriler' && this.item.title !== 'Markalar' && this.item.title !== 'Ürünler' && (this.item.title !== 'Kullanıcılar')) {
            this.submenu = true;
        }
    }
}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadviceadminSkeleton/src/app/core/components/navigation/vertical/nav-item/nav-vertical-item.component.ts